exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination[data-v-423ef8e2] {\n  max-width: 70%;\n  padding: 0;\n  margin: 0;\n  display: inline;\n}\n.pagination li[data-v-423ef8e2] {\n    display: inline;\n}\n", ""]);

// exports
